import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Link } from 'react-router';
import { Button } from '../../Button/index.js';
import { FAIcon } from '../../fa-icon/component.js';
import { pickDataAttributes } from '../../../utils/pickDataAttributes.js';

var CreateButton = function CreateButton(_ref) {
  var createButton = _ref.createButton,
      createButtonIcon = _ref.createButtonIcon,
      createButtonType = _ref.createButtonType,
      createAction = _ref.createAction;
  var dataAttributes = pickDataAttributes({
    createButton: createButton,
    createButtonIcon: createButtonIcon,
    createButtonType: createButtonType,
    createAction: createAction
  });

  if (!createButton) {
    return null;
  }

  if (createButtonType === 'link') {
    return /*#__PURE__*/React.createElement(Link, {
      to: "/add"
    }, /*#__PURE__*/React.createElement(Button, _extends({
      style: "primary"
    }, dataAttributes), createButtonIcon && /*#__PURE__*/React.createElement(FAIcon, {
      icon: createButtonIcon
    }), createButton));
  } else {
    return /*#__PURE__*/React.createElement(Button, _extends({
      style: "primary",
      onClick: function onClick(e) {
        return createAction && createAction(e);
      }
    }, dataAttributes), createButtonIcon && /*#__PURE__*/React.createElement(FAIcon, {
      icon: createButtonIcon
    }), createButton);
  }
};

export { CreateButton };